module.exports = __webpack_public_path__ + "img/20220809153624.b53779b0.jpg";